import React from 'react';
import '../../styles/TypingIndicator.css';

/**
 * Animated typing indicator component
 * Shows three bouncing dots to indicate someone is typing
 */
const TypingIndicator = ({ userName }) => {
  return (
    <div className="typing-indicator-container">
      <div className="typing-indicator-bubble">
        <div className="typing-indicator-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;

